const bestDeals = [
  {
    id: 1,
    name: "Floral Summer Dress",
    price: "€15",
    oldPrice: "€22",
    discount: "30% OFF",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab",
    brand: "Zara Style",
  },
  {
    id: 2,
    name: "Printed Casual Dress",
    price: "€12",
    oldPrice: "€16",
    discount: "25% OFF",
    image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d",
    brand: "H&M",
  },
  {
    id: 3,
    name: "Elegant Party Outfit",
    price: "€25",
    oldPrice: "€32",
    discount: "20% OFF",
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7",
    brand: "Forever 21",
  },
  {
    id: 4,
    name: "Luxury Perfume",
    price: "€40",
    oldPrice: "€55",
    discount: "22% OFF",
    image: "https://images.unsplash.com/photo-1598033129183-c4f50c736f10",
    brand: "Gucci",
  },
  {
    id: 5,
    name: "Stylish Handbag",
    price: "€20",
    oldPrice: "€27",
    discount: "25% OFF",
    image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3",
    brand: "Lavie",
  },
  {
    id: 6,
    name: "Trendy Sneakers",
    price: "€30",
    oldPrice: "€42",
    discount: "28% OFF",
    image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2",
    brand: "Nike",
  },
  {
    id: 7,
    name: "Denim Jacket",
    price: "€24",
    oldPrice: "€32",
    discount: "26% OFF",
    image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246",
    brand: "Levis",
  },
  {
    id: 8,
    name: "Casual T-Shirt",
    price: "€8",
    oldPrice: "€13",
    discount: "38% OFF",
    image: "https://images.unsplash.com/photo-1520975916090-3105956dac38",
    brand: "Roadster",
  },
  {
    id: 9,
    name: "Formal Shirt",
    price: "€15",
    oldPrice: "€22",
    discount: "30% OFF",
    image: "https://images.unsplash.com/photo-1598033129183-c4f50c736f10",
    brand: "Peter England",
  },
  {
    id: 10,
    name: "Summer Shorts",
    price: "€10",
    oldPrice: "€15",
    discount: "33% OFF",
    image: "https://images.unsplash.com/photo-1562157873-818bc0726f68",
    brand: "Puma",
  },
  {
    id: 11,
    name: "Sports Hoodie",
    price: "€28",
    oldPrice: "€38",
    discount: "27% OFF",
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7",
    brand: "Adidas",
  },
  {
    id: 12,
    name: "Women Heels",
    price: "€22",
    oldPrice: "€30",
    discount: "28% OFF",
    image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2",
    brand: "Metro",
  },
  {
    id: 13,
    name: "Ethnic Kurti",
    price: "€12",
    oldPrice: "€18",
    discount: "33% OFF",
    image: "https://images.unsplash.com/photo-1583391733956-6c78276477e2",
    brand: "Biba",
  },
  {
    id: 14,
    name: "Leather Wallet",
    price: "€8",
    oldPrice: "€14",
    discount: "44% OFF",
    image: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519",
    brand: "Fastrack",
  },
  {
    id: 15,
    name: "Smart Watch",
    price: "€35",
    oldPrice: "€50",
    discount: "33% OFF",
    image: "https://images.unsplash.com/photo-1517433456452-f9633a875f6f",
    brand: "Noise",
  },
];

export default bestDeals;